module.exports = __webpack_public_path__ + "img/picto1.aa220235.svg";